import React, { useEffect, useRef, useState } from "react";
import { ChevronRight, Cpu } from "lucide-react";
import { SECTION_COLORS } from "../../navigation/navConfig";

const useClock = () => {
  const [t, setT] = useState(() => new Date());
  useEffect(() => { const id = setInterval(() => setT(new Date()), 1000); return () => clearInterval(id); }, []);
  return t.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
};

const Panel = ({ s, i, badges, onGo }) => {
  const ref = useRef(null);
  const I = s.icon;
  const onMove = (e) => {
    const el = ref.current; if (!el) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
    el.style.setProperty('--mx', `${x * 100}%`); el.style.setProperty('--my', `${y * 100}%`);
    el.style.transform = `perspective(900px) rotateX(${(0.5 - y) * 7}deg) rotateY(${(x - 0.5) * 9}deg) translateY(-4px)`;
  };
  const onLeave = () => { const el = ref.current; if (el) el.style.transform = ''; };
  const alerts = s.pages.reduce((a, p) => a + (badges?.[p.badge] || 0), 0);
  return (
    <div ref={ref} className={`opn-fxm2__panel ${alerts > 0 ? 'has-alerts' : ''}`} style={{ '--sec': SECTION_COLORS[s.id], animationDelay: `${i * 110}ms` }} onMouseMove={onMove} onMouseLeave={onLeave} data-testid={`fx-menu-${s.id}`}>
      <div className="opn-fxm2__inner">
        <span className="opn-fxm2__scan" aria-hidden="true" />
        <span className="opn-fxm2__holo" aria-hidden="true" />
        <span className="opn-fxm2__spot" aria-hidden="true" />
        <header className="opn-fxm2__head">
          <span className="opn-fxm2__radar"><span className="opn-fxm2__sweep" /><I className="h-4 w-4" /></span>
          <span className="opn-fxm2__label" data-text={s.label}>{s.label}</span>
          <span className="opn-fxm2__status"><i />{alerts > 0 ? `${alerts} alerte${alerts > 1 ? 's' : ''}` : 'en ligne'}</span>
        </header>
        <div className="opn-fxm2__stream" aria-hidden="true">{Array.from({ length: 14 }).map((_, k) => <i key={k} style={{ animationDelay: `${k * 0.18}s` }} />)}</div>
        <div className="opn-fxm2__items">
          {s.pages.map((p, j) => { const PI = p.icon; const n = badges?.[p.badge]; return (
            <button key={p.id} type="button" className={`opn-fxm2__item ${n > 0 ? 'has-badge' : ''}`} style={{ animationDelay: `${i * 110 + 220 + j * 70}ms` }} onClick={() => onGo(p.lien || `${s.path}/${p.path}`)} data-testid={`home-menu-${s.id}-${p.id}`}>
              <span className="opn-fxm2__idx">{String(j + 1).padStart(2, '0')}</span>
              <PI className="opn-fxm2__ico" />
              <span className="opn-fxm2__txt" style={{ animationDelay: `${i * 110 + 320 + j * 70}ms` }}>{p.label}</span>
              {n > 0 && <span className="opn-fxm2__badge">{n}</span>}
              <ChevronRight className="opn-fxm2__go" />
            </button>); })}
        </div>
        <footer className="opn-fxm2__foot">
          <span className="opn-fxm2__eq"><i /><i /><i /><i /><i /></span>
          <span>{s.pages.length} module{s.pages.length > 1 ? 's' : ''}</span>
          <span className="opn-fxm2__code">SEC-{String(i + 1).padStart(2, '0')}</span>
        </footer>
      </div>
    </div>
  );
};

const FuturMenu = ({ tree, badges, onGo }) => {
  const clock = useClock();
  const total = tree.sections.reduce((a, s) => a + s.pages.length, 0);
  return (
    <section className="opn-fxm2" data-testid="home-menu">
      <header className="opn-fxm2__bar">
        <span className="opn-fxm2__bar-k"><Cpu className="h-3.5 w-3.5" /> Systèmes</span>
        <span className="opn-fxm2__bar-line" />
        <span className="opn-fxm2__bar-info">{tree.sections.length} rubriques · {total} écrans</span>
        <span className="opn-fxm2__clock" data-testid="fx-clock">{clock}</span>
      </header>
      <div className="opn-fxm2__grid">
        {tree.sections.map((s, i) => <Panel key={s.id} s={s} i={i} badges={badges} onGo={onGo} />)}
      </div>
    </section>
  );
};

export default FuturMenu;
